<template>
    <div>
        <table class="table table-striped table-class hidden-sm hidden-xs">
            <thead>
                <tr>
                    <th 
                        v-for="(header, idx) in headers" 
                        :key="idx" 
                        @click="sortBy(idx, header.type)"
                        class="dashboard-sort-header"
                        
                    >
                        <span v-if="sortColumn == idx">
                            <font-awesome-icon v-if="sortDirection != 'asc'" :icon="['fas', 'chevron-up']" />
                            <font-awesome-icon v-if="sortDirection != 'desc'" :icon="['fas', 'chevron-down']" />
                        </span>
                        {{ header.label }}
                    </th>                    
                    <th class="dashboard-sort-header">Image</th>
                    <th class="dashboard-sort-header">Link</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in paginatedData" :key="index">
                    <td>{{ item.title }}</td>
                    <td>{{ formatNumeric(item.price, 'money') }}</td>
                    <td>{{ formatNumeric(item.score) }}</td>
                    <td>
                        <img 
                            v-if="item.image" 
                            :src="decodeImageURL(item.image)" 
                            alt="Image" 
                            class="search-result-image"
                        />
                        <span v-else>No Image</span>
                    </td>
                    
                    <td class="search-result-link-cell">
                        <div class="search-result-link-wrap">
                            <a :href="item.link" target="_blank" rel="noopener noreferrer" class="visit-link">
                                Visit Link
                            </a>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="d-flex justify-content-between align-items-center my-3">
            <div>
                <label for="itemsPerPage" class="me-2">Items per page:</label>
                <select 
                    id="itemsPerPage" 
                    v-model="itemsPerPage" 
                    @change="handleItemsPerPageChange" 
                    class="form-select d-inline-block w-auto"
                >
                    <option v-for="option in [10, 20, 50, 100]" :key="option" :value="option">
                        {{ option }}
                    </option>
                </select>
            </div>

            <div>
                <button 
                    class="btn btn-danger" 
                    @click="changePage(currentPage - 1)" 
                    :disabled="currentPage === 1"
                >
                    Previous
                </button>
                <span class="mx-3">
                    Page <strong>{{ currentPage }}</strong> of <strong>{{ totalPages }}</strong>
                </span>
                <button 
                    class="btn btn-danger" 
                    @click="changePage(currentPage + 1)" 
                    :disabled="currentPage === totalPages"
                >
                    Next
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { formatNumeric } from '@/helpers/string.js'

export default {
    name: 'GoogleSearchTable',
    props: {
        data: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            headers: [
                {label: "Title", type: "string"},
                {label: "Price", type: "numeric"},
                {label: "Score", type: "numeric"},
            ],
            columnType: 'string',
            sortColumn: 0,
            sortDirection: 'asc',
            currentPage: 1,
            itemsPerPage: 10,
        };
    },
    computed: {
        sortedData() {
            return this.data.slice().sort((a, b) => {
                const key = this.getColumnKey(this.sortColumn);
                let valueA = a[key];
                let valueB = b[key];

                if (this.columnType === "numeric") {
                    valueA = Number(String(valueA).replace('%', '')) || 0;
                    valueB = Number(String(valueB).replace('%', '')) || 0;
                } else if (this.columnType === "date") {
                    valueA = new Date(valueA);
                    valueB = new Date(valueB);
                } else {
                    valueA = String(valueA).toLowerCase();
                    valueB = String(valueB).toLowerCase();
                }

                return this.sortDirection === "asc" ? (valueA > valueB ? 1 : -1) : (valueA < valueB ? 1 : -1);
            });
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.sortedData.slice(start, end);
        },
        totalPages() {
            return Math.ceil(this.data.length / this.itemsPerPage);
        },
    },
    methods: {
        formatNumeric,
        getColumnKey(index) {
            const keys = [
                'title',
                'price',
                'score',
                'image',
                'link',
                'product_link',
            ];
            return keys[index];
        },
        decodeImageURL(encodedURL) {
            return encodedURL;
        },
        sortBy(columnIndex, columnType) {
            this.columnType = columnType;

            if (this.sortColumn === columnIndex) {
                this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
            } else {
                this.sortColumn = columnIndex;
                this.sortDirection = 'asc';
            }
        },
        changePage(page) {
            if (page > 0 && page <= this.totalPages) {
                this.currentPage = page;
            }
        },
        handleItemsPerPageChange() {
            this.currentPage = 1;
        },
    },
};
</script>


<style scoped>
.visit-link {
    color: var(--color-brand-primary) !important;
    font-weight: 600;
    text-decoration: none;
}

.search-result-image {
    max-width: 100px;
    max-height: 100px;
}

.search-result-link-cell {
    width: 150px !important;
}

.search-result-link-wrap {
    width: 100px !important;
    word-wrap: break-word;
}

.table thead td, .table thead th {
    font-size: 15px;
    font-weight: 700;
    text-transform: uppercase;
}
</style>
